export default __webpack_public_path__ + "static/media/tether_usdt_icon.9c29dc9b.svg";